//import CoolenWordStudyData from "@/pcomponents/common/content/coolen/study/func/word_study_data";
import strFunc from "@/lib/lyg/string";

class CoolenWordStudyData {
  static data: any = {
    study_sort_arr: [
      { value: "contents_book", text: "콘텐츠북" },
      { value: "abc_study", text: "ABC학습" },
      { value: "word_study", text: "단어학습" },
      { value: "word_school", text: "내신본문" },
      { value: "cg_word", text: "단어숙제" },
    ],
    study_sort_json: {
      contents_book: {
        study_sort_arr: [
          { value: "word", text: "WORD", m_text: "WORD" },
          { value: "word_test", text: "WORD TEST", m_text: "TEST" },
          { value: "sentence", text: "SENTENCE", m_text: "STC" },
          { value: "sentence_test", text: "SENTENCE TEST", m_text: "TEST" },
        ],
        study_sort_det_arr: [
          { value: "select_word", text: "Select", sort: "word", cont_part: "word" },
          { value: "listening", text: "Listening", sort: "word", cont_part: "word" },
          // { value: "speaking", text: "Speaking", sort: "word", cont_part: "word" },
          { value: "dictation", text: "Dictation", sort: "word", cont_part: "word" },
          { value: "writing", text: "Writing", sort: "word", cont_part: "word" },

          { value: "majak", text: "WordGame", sort: "word_test", cont_part: "word" },
          { value: "dic_test", text: "Dictation", sort: "word_test", cont_part: "word" },
          { value: "writing_test", text: "Writing", sort: "word_test", cont_part: "word" },
          { value: "white_paper_test", text: "White Mission", sort: "word_test", cont_part: "word" },

          { value: "select_word", text: "Select", sort: "sentence", cont_part: "stc" },
          { value: "listening", text: "Listening", sort: "sentence", cont_part: "stc" },
          // { value: "speaking", text: "Speaking", sort: "sentence", cont_part: "stc" },
          { value: "shadowing", text: "Shadowing", sort: "sentence", cont_part: "stc" },
          { value: "word_order", text: "WordOrder", sort: "sentence", cont_part: "stc" },
          { value: "dictation", text: "Dictation", sort: "sentence", cont_part: "stc" },
          { value: "writing", text: "Writing", sort: "sentence", cont_part: "stc" },
          // { value: "trans", text: "TransMisson", sort: "sentence", cont_part: "stc" },

          { value: "dic_test", text: "Dictation", sort: "sentence_test", cont_part: "stc" },
          { value: "writing_test", text: "Writing", sort: "sentence_test", cont_part: "stc" },
          { value: "white_paper_test", text: "White Mission", sort: "sentence_test", cont_part: "stc" },
        ],
      },
      abc_study: {
        study_sort_arr: [
          { value: "abc", text: "ABC", m_text: "ABC" },
          { value: "abc_game_test", text: "Game", m_text: "Game" },
        ],
        study_sort_det_arr: [
          { value: "select_word", text: "Select", sort: "abc", cont_part: "word" },
          { value: "listen_card", text: "Card", sort: "abc", cont_part: "word" },
          { value: "listen_board", text: "Board", sort: "abc", cont_part: "word" },
          // { value: "up_low_pair", text: "Pair", sort: "abc", cont_part: "word" },
          // { value: "sound_mean", text: "Match", sort: "abc", cont_part: "word" },

          { value: "rain_game", text: "Rain", sort: "abc_game_test", cont_part: "word" },
        ],
      },
      word_study: {
        study_sort_arr: [
          { value: "word", text: "WORD", m_text: "WORD" },
          { value: "word_test", text: "WORD TEST", m_text: "TEST" },
          { value: "sentence", text: "SENTENCE", m_text: "STC" },
          { value: "sentence_test", text: "SENTENCE TEST", m_text: "TEST" },
        ],
        study_sort_det_arr: [
          { value: "select_word", text: "Select", sort: "word", cont_part: "word" },
          { value: "listening", text: "Listening", sort: "word", cont_part: "word" },
          // { value: "speaking", text: "Speaking", sort: "word", cont_part: "word" },
          { value: "dictation", text: "Dictation", sort: "word", cont_part: "word" },
          { value: "writing", text: "Writing", sort: "word", cont_part: "word" },

          { value: "majak", text: "WordGame", sort: "word_test", cont_part: "word" },
          { value: "dic_test", text: "Dictation", sort: "word_test", cont_part: "word" },
          { value: "writing_test", text: "Writing", sort: "word_test", cont_part: "word" },
          { value: "white_paper_test", text: "White Mission", sort: "word_test", cont_part: "word" },

          { value: "select_word", text: "Select", sort: "sentence", cont_part: "stc" },
          { value: "listening", text: "Listening", sort: "sentence", cont_part: "stc" },
          // { value: "speaking", text: "Speaking", sort: "sentence", cont_part: "stc" },
          { value: "shadowing", text: "Shadowing", sort: "sentence", cont_part: "stc" },
          { value: "word_order", text: "WordOrder", sort: "sentence", cont_part: "stc" },
          { value: "dictation", text: "Dictation", sort: "sentence", cont_part: "stc" },
          { value: "writing", text: "Writing", sort: "sentence", cont_part: "stc" },
          // { value: "trans", text: "TransMisson", sort: "sentence", cont_part: "stc" },

          { value: "dic_test", text: "Dictation", sort: "sentence_test", cont_part: "stc" },
          { value: "writing_test", text: "Writing", sort: "sentence_test", cont_part: "stc" },
          { value: "white_paper_test", text: "White Mission", sort: "sentence_test", cont_part: "stc" },
        ],
      },
      word_school: {
        study_sort_arr: [
          { value: "sentence", text: "문장<br />학습", m_text: "STC" },
          { value: "sentence_test", text: "SENTENCE TEST", m_text: "TEST" },
        ],
        study_sort_det_arr: [
          // { value: "select_word", text: "Select", sort: "sentence", cont_part: "stc", m_text: "Se" },
          { value: "listening", text: "Listening", sort: "sentence", cont_part: "stc", m_text: "Li" },
          // { value: "speaking", text: "Speaking", sort: "sentence", cont_part: "stc", m_text: "Sp" },
          { value: "shadowing", text: "Shadowing", sort: "sentence", cont_part: "stc", m_text: "Sh" },
          { value: "word_order", text: "WordOrder", sort: "sentence", cont_part: "stc", m_text: "Wo" },
          { value: "dictation", text: "Dictation", sort: "sentence", cont_part: "stc", m_text: "Di" },
          { value: "writing", text: "Writing", sort: "sentence", cont_part: "stc", m_text: "Wr" },
          // { value: "trans", text: "TransMisson", sort: "sentence", cont_part: "stc" },

          { value: "dic_test", text: "Dictation", sort: "sentence_test", cont_part: "stc", m_text: "Di" },
          { value: "writing_test", text: "Writing", sort: "sentence_test", cont_part: "stc", m_text: "Wr" },
          { value: "white_paper_test", text: "W.Mission", sort: "sentence_test", cont_part: "stc", m_text: "Wm" },
        ],
      },
      cg_word: {
        study_sort_arr: [
          { value: "word", text: "WORD", m_text: "WORD" },
          { value: "word_test", text: "WORD TEST", m_text: "TEST" },
        ],
        study_sort_det_arr: [
          // { value: "select_word", text: "Select", sort: "word", cont_part: "word" },
          { value: "listening", text: "Listening", sort: "word", cont_part: "word" },
          // { value: "speaking", text: "Speaking", sort: "word", cont_part: "word" },
          { value: "dictation", text: "Dictation", sort: "word", cont_part: "word" },
          { value: "writing", text: "Writing", sort: "word", cont_part: "word" },

          { value: "majak", text: "WordGame", sort: "word_test", cont_part: "word" },
          { value: "dic_test", text: "Dictation", sort: "word_test", cont_part: "word" },
          { value: "writing_test", text: "Writing", sort: "word_test", cont_part: "word" },
          { value: "white_paper_test", text: "White Mission", sort: "word_test", cont_part: "word" },
        ],
      },
    },

  };
  static get_study_sort_arr = (inData: any) => {
    let opt_obj = {
      study_sort: "contents_book",
      ...inData
    };
    let this_obj = this;
    let study_sort_arr: any = [];
    if (this_obj.data.study_sort_json[opt_obj.study_sort]) {
      study_sort_arr = this_obj.data.study_sort_json[opt_obj.study_sort].study_sort_arr;
    }
    return study_sort_arr;
  };
  static get_study_det_arr = (inData: any) => {
    let opt_obj = {
      study_sort: "contents_book",
      ...inData
    };
    let this_obj = this;
    let study_sort_det_arr: any = [];
    if (this_obj.data.study_sort_json[opt_obj.study_sort]) {
      study_sort_det_arr = this_obj.data.study_sort_json[opt_obj.study_sort].study_sort_det_arr;
    }
    return study_sort_det_arr;
  };
}
export default CoolenWordStudyData;